import tdaConfig from 'lib/util/tda.config';
import paramByName from 'lib/getParameterByName';
import rtiDealerCode from './rtiDealerCode';

var __userDealerCode = rtiDealerCode.hasRti() ? rtiDealerCode.savedDealerCode() : 'Toyota';
export default function __dgConfig() {
  //  Always try and set the DealerCode to what's in the URL. This will allow us to spot a deep link.
  // it will trigger the garage based change.
  var dealer_code = paramByName('dealerCd') || __userDealerCode;
  window.DGDataHub = window.DGDataHub || {};
  window.DGDataHub.dealerCd = dealer_code;
  window.DGDataHub.spaRoot = `/${tdaConfig.site.context_url}/saves`;
  window.DGDataHub.components = { 'dg-nav-menu': { version: '1-0' }, 'dg-inline-saves': { version: '1-0' } };
  window.DGDataHub.loadNewDealer = function (garageDealerCode, garageZipCode) {};
  window.DGDataHub.pageRoutes = {};
  window.DGDataHub.pageRoutes.loginDataParserRoute = '/loginDataParserGxp';
  window.DGDataHub.continuePageLoad = function () {
    // console.log('%c continue page load:', 'background: blue; color: white');
    // if deep link and no dealer_code cookies, set them now with data? provided
    /*
    If there is no need/opportunity to select a dealer in the zip code, then there is no need to do anything here
    If there is a need/opportunity to select a dealer in the zip code, launch the dealer select modal
    If this is a deep-link dealer conflict on an inventory page, you may continue loading content on the page
    */
  };
  window.DGDataHub.updateSaveItem = function () {};
  /* console.log('%c window.DGDataHub updated', 'background: green; color: white');
  console.log(window.DGDataHub); */
};
